import ProductPageLayout from "@/components/ProductPageLayout";
import kaihtimet from "@/assets/kaihtimet.png?format=webp&w=800";

const BlindInstallation = () => (
  <ProductPageLayout title="Blind installation" metaDescription="Professional blind installation in Central Uusimaa. Blackout & smart blinds, motorized blinds, mosquito nets." image={kaihtimet} partner="solar" path="/en/blind-installation" alternatePath="/kaihdin-asennus">
    <p className="text-muted-foreground leading-relaxed">
      Blinds are one of the most popular window solutions – and for good reason. We offer blackout & smart blinds, 
      motorized blinds and mosquito nets. Professionally installed with care and precision.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Why choose professional installation?</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Precise measuring ensures a perfect fit</li>
      <li>✓ Clean and quick installation without damaging window frames</li>
      <li>✓ Correct mounting method for every window type</li>
      <li>✓ Solar Kaihdin warranty products</li>
    </ul>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Service area</h2>
    <p className="text-muted-foreground leading-relaxed">
      We offer blind installation across the Central Uusimaa region: Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula. 
      Browse the <a href="https://solar.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Solar Kaihdin range</a> and 
      contact us to find the right solution.
    </p>
  </ProductPageLayout>
);

export default BlindInstallation;
